import Box from '@mui/material/Box';

import { Icon } from 'common/components/Icon';

export type TBudgetRequestTimeLineStepColor =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'warning'
    | 'info';

export interface IBudgetRequestTimeLineStepProps {
    iconPath: string;
    color?: TBudgetRequestTimeLineStepColor;
    showConnector?: boolean;
    children: React.ReactNode;
}

export const BudgetRequestTimeLineStep = ({
    iconPath,
    color = 'primary',
    showConnector = false,
    children,
}: IBudgetRequestTimeLineStepProps) => (
    <Box sx={{ display: 'flex', gap: 2 }}>
        <Box
            sx={{
                display: 'flex',
                flexShrink: 0,
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    bgcolor: `${color}.main`,
                    color: `${color}.contrastText`,
                }}
            >
                <Icon path={iconPath} size="1.9rem" />
            </Box>

            {showConnector && (
                <Box
                    sx={{
                        flex: 1,
                        width: '2px',
                        minHeight: 24,
                        bgcolor: 'divider',
                    }}
                />
            )}
        </Box>

        <Box sx={{ pb: showConnector ? 3 : 0 }}>{children}</Box>
    </Box>
);
